<section class="elegibilidade" aria-labelledby="valor-minimo-saldo-titulo" data-testid="beneficios-valor-minimo-saldo">
  <header class="elegibilidade__topo">
    <span class="elegibilidade__icone" aria-hidden="true">
      <vivest-icon name="shield" source="feather"></vivest-icon>
    </span>
    <div class="elegibilidade__titulo-grupo">
      <h2 id="valor-minimo-saldo-titulo" class="elegibilidade__titulo">Regra valor mínimo do saldo</h2>
      <p class="elegibilidade__descricao">
        Configure o valor mínimo de recebimento do plano, por valor fixo ou regra variável. Vale para todos os benefícios.
      </p>
    </div>
  </header>

  @if (carregou()) {
    <div class="elegibilidade__blocos">
      <section class="elegibilidade-parametros" aria-labelledby="valor-minimo-saldo-parametros-titulo">
        <div class="elegibilidade-parametros__cabecalho">
          <h3 id="valor-minimo-saldo-parametros-titulo" class="elegibilidade__subtitulo">
            Parâmetros do Valor Mínimo{{ nomePlano() ? ': ' : '' }}
            @if (nomePlano()) {
              <span class="elegibilidade-parametros__beneficio" data-testid="valor-minimo-saldo-plano">{{ nomePlano() }}</span>
            }
          </h3>
        </div>

        <form
          class="elegibilidade-regras"
          novalidate
          [formGroup]="form"
          (submit)="$event.preventDefault(); salvar()"
          data-testid="valor-minimo-saldo-form"
        >
          <fieldset class="elegibilidade-bloco" aria-labelledby="valor-minimo-saldo-bloco" data-testid="valor-minimo-saldo-bloco">
            <div class="elegibilidade-bloco__cabecalho">
              <h4 id="valor-minimo-saldo-bloco" class="elegibilidade-bloco__titulo">Regra de valor mínimo do saldo</h4>
              <p class="elegibilidade-bloco__regra">O participante não recebe abaixo do valor mínimo definido aqui.</p>
            </div>
            <div class="elegibilidade-bloco__conteudo">
              <div class="elegibilidade-interruptor">
                <vivest-switch
                  formControlName="habilitada"
                  aria-labelledby="valor-minimo-saldo-habilitar-rotulo"
                  data-testid="valor-minimo-saldo-habilitar"
                ></vivest-switch>
                <span id="valor-minimo-saldo-habilitar-rotulo" class="elegibilidade-interruptor__texto">
                  Habilitar regra de valor mínimo do saldo
                  <span class="elegibilidade-interruptor__estado">{{ form.controls.habilitada.value ? 'Sim' : 'Não' }}</span>
                </span>
              </div>

              <!-- Desligada, os valores ficam guardados e voltam ao religar. -->
              @if (form.controls.habilitada.value) {
                <div class="elegibilidade-detalhe" data-testid="valor-minimo-saldo-detalhe">
                  <!-- Valor fixo ou regra variável: excludentes, cada um guarda o próprio valor. -->
                  <div class="valor-minimo-saldo-definir">
                    <span id="valor-minimo-saldo-tipo-rotulo" class="valor-minimo-saldo-definir__rotulo">Definir por</span>
                    <span
                      class="elegibilidade-prazo__unidades"
                      role="radiogroup"
                      aria-labelledby="valor-minimo-saldo-tipo-rotulo"
                      data-testid="valor-minimo-saldo-tipo"
                    >
                      @for (tipo of tipos; track tipo.value) {
                        <label class="elegibilidade-prazo__unidade" [class.elegibilidade-prazo__unidade--ativa]="form.controls.tipo.value === tipo.value">
                          <input
                            type="radio"
                            class="elegibilidade-prazo__radio"
                            name="tipo"
                            [value]="tipo.value"
                            formControlName="tipo"
                            [attr.data-testid]="'valor-minimo-saldo-tipo-' + tipo.value"
                          />
                          {{ tipo.label }}
                        </label>
                      }
                    </span>
                  </div>

                  @if (form.controls.tipo.value === 'fixo') {
                    <p class="elegibilidade-frase" data-testid="valor-minimo-saldo-frase-fixo">
                      <span>Mínimo de</span>
                      <span class="elegibilidade-moeda">
                        <span class="elegibilidade-moeda__prefixo" aria-hidden="true">R$</span>
                        <input
                          type="text"
                          inputmode="numeric"
                          appMascaraMoeda
                          placeholder="0,00"
                          aria-label="Valor mínimo de recebimento em reais"
                          class="form-control campanha-form-control elegibilidade-moeda__input"
                          formControlName="valor"
                          [class.is-invalid]="!!erro()"
                          data-testid="valor-minimo-saldo-valor"
                        />
                      </span>
                      <span>por recebimento</span>
                    </p>
                  } @else {
                    <!-- O mínimo é a variável escolhida multiplicada pelo multiplicador (ex.: Salário × 1). -->
                    <div class="valor-minimo-saldo-regra" data-testid="valor-minimo-saldo-regra-variavel">
                      <vivest-select
                        class="valor-minimo-saldo-regra__variavel"
                        label="Variável"
                        name="variavel-valor-minimo"
                        placeholder="Selecione a variável"
                        required
                        [options]="variaveis"
                        formControlName="variavel"
                        [status]="erroVariavel() ? 'error' : 'default'"
                        [attr.error-message]="erroVariavel()"
                        data-testid="valor-minimo-saldo-variavel"
                      ></vivest-select>
                      <span class="valor-minimo-saldo-regra__vezes" aria-hidden="true">×</span>
                      <div class="elegibilidade-campo valor-minimo-saldo-regra__multiplicador">
                        <label class="valor-minimo-saldo-regra__rotulo" for="valor-minimo-saldo-multiplicador">
                          Multiplicador<span class="campanha-form-required" aria-hidden="true">*</span>
                        </label>
                        <input
                          id="valor-minimo-saldo-multiplicador"
                          type="number"
                          inputmode="decimal"
                          min="0.01"
                          step="0.01"
                          placeholder="1"
                          class="form-control campanha-form-control valor-minimo-saldo-regra__input"
                          formControlName="multiplicador"
                          [class.is-invalid]="!!erroMultiplicador()"
                          data-testid="valor-minimo-saldo-multiplicador"
                        />
                      </div>
                    </div>
                  }
                  @if (erroValorOuMultiplicador(); as mensagem) {
                    <p class="elegibilidade__erro" role="alert" data-testid="valor-minimo-saldo-erro">{{ mensagem }}</p>
                  }
                </div>
              }
            </div>
          </fieldset>
        </form>
      </section>

      <aside class="elegibilidade-resumo" aria-labelledby="valor-minimo-saldo-resumo-titulo" data-testid="valor-minimo-saldo-resumo">
        <h3 id="valor-minimo-saldo-resumo-titulo" class="elegibilidade-resumo__titulo">Resumo{{ nomePlano() ? ' (' + nomePlano() + ')' : '' }}</h3>
        <ul class="elegibilidade-resumo__itens" data-testid="valor-minimo-saldo-resumo-itens">
          @for (item of resumo(); track $index) {
            <li>{{ item }}</li>
          }
        </ul>
      </aside>
    </div>

    <footer class="elegibilidade__rodape">
      @if (temAlteracoes()) {
        <span class="elegibilidade__pendente" data-testid="valor-minimo-saldo-alteracoes-pendentes">Há alterações não salvas</span>
      }
      <vivest-button variant="outline" size="md" [disabled]="!temAlteracoes()" data-testid="valor-minimo-saldo-cancelar" (click)="descartar()">
        Cancelar
      </vivest-button>
      <vivest-button variant="primary" size="md" [disabled]="!temAlteracoes()" data-testid="valor-minimo-saldo-salvar" (click)="salvar()">
        <vivest-icon slot="icon-left" name="save" source="feather"></vivest-icon>
        {{ salvando() ? 'Salvando…' : 'Salvar' }}
      </vivest-button>
    </footer>
  }
</section>

<vivest-modal
  heading="Salvar regra de valor mínimo do saldo"
  description="A regra passa a valer para todos os benefícios do plano nas próximas solicitações. Confirma?"
  [open]="confirmandoSalvar()"
  [hasIcon]="false"
  dismissible=""
  (vivest-close)="confirmandoSalvar.set(false)"
  data-testid="valor-minimo-saldo-confirmar"
>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="valor-minimo-saldo-confirmar-voltar" (click)="confirmandoSalvar.set(false)">
    Voltar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="valor-minimo-saldo-confirmar-salvar" (click)="confirmarSalvar()">
    Salvar
  </vivest-button>
</vivest-modal>
